import { writable } from "svelte/store";
import API from './Api';

const tokenSession = sessionStorage.getItem('token');

let logged = false;

if (undefined !== tokenSession && '' !== tokenSession && null !== tokenSession) {
    logged = true;
}

export const loggedIn = writable(logged);

export const logout = () => {
    logged = false;
    API.get('auth/logout');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('userID');
    window.location.href = '/';
};